import EmailManagement from './EmailManagement';
export default EmailManagement;
